import React from 'react';
import AdminLayout from '../../components/admin/AdminLayoutOptimized';
import ReferralsManagement from '../../components/admin/referrals/ReferralsManagement';

const ReferralsManagementPage: React.FC = () => {
  return (
    <AdminLayout>
      <div className="container mx-auto px-4 py-6">
        <h1 className="text-2xl font-bold mb-6">Gestion des redirections</h1>
        <ReferralsManagement />
      </div>
    </AdminLayout>
  );
};

export default ReferralsManagementPage;
